<adaa-data-table
    #adaaDataTable
    apiName="forecastedValuesMetrics"
    [titleHeader]="('forecasted_values.title_plural' | translate) + ' - ' + ('breadcrumbs.metrics' | translate)"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.FORECASTED_VALUES_METRICS_CONF_LIST"
    [enableAdd]="false"
    [enableDeleteAction]="false"
    (actionClicked)="actionClicked($event)"
/>
